import * as actionTypes from '../types/decision';
/** Получить решение по УЕ */
export function getDecision(payload) {
  return {
    type: actionTypes.GET_DECISION,
    payload
  };
}
export function getDecisionSuccess(payload) {
  return {
    type: actionTypes.GET_DECISION_SUCCESS,
    payload
  };
}
export function getDecisionFail(payload) {
  return {
    type: actionTypes.GET_DECISION_FAIL,
    payload
  };
}
/** Получить список решений */
export function getDecisionsList(payload) {
  return {
    type: actionTypes.GET_DECISIONS_LIST,
    payload
  };
}
export function getDecisionsListSuccess(payload) {
  return {
    type: actionTypes.GET_DECISIONS_LIST_SUCCESS,
    payload
  };
}
export function getDecisionsListFail(payload) {
  return {
    type: actionTypes.GET_DECISIONS_LIST_FAIL,
    payload
  };
}
/** УЕ в карантин */
export function setHoldOn(payload) {
  return {
    type: actionTypes.SET_HOLD_ON,
    payload
  };
}
export function setHoldOnSuccess(payload) {
  return {
    type: actionTypes.SET_HOLD_ON_SUCCESS,
    payload
  };
}
export function setHoldOnFail(payload) {
  return {
    type: actionTypes.SET_HOLD_ON_FAIL,
    payload
  };
}
/** Сохранить решение из списка */
export function saveDecision(payload) {
  return {
    type: actionTypes.SAVE_DECISION,
    payload
  };
}
export function saveDecisionSuccess(payload) {
  return {
    type: actionTypes.SAVE_DECISION_SUCCESS,
    payload
  };
}
export function saveDecisionFail(payload) {
  return {
    type: actionTypes.SAVE_DECISION_FAIL,
    payload
  };
}
/** Отклонить решение */
export function declineDecision(payload) {
  return {
    type: actionTypes.DECLINE_DECISION,
    payload
  };
}
export function declineDecisionSuccess(payload) {
  return {
    type: actionTypes.DECLINE_DECISION_SUCCESS,
    payload
  };
}
export function declineDecisionFail(payload) {
  return {
    type: actionTypes.DECLINE_DECISION_FAIL,
    payload
  };
}
/** Принять решение */
export function acceptDecision(payload) {
  return {
    type: actionTypes.ACCEPT_DECISION,
    payload
  };
}
export function acceptDecisionSuccess(payload) {
  return {
    type: actionTypes.ACCEPT_DECISION_SUCCESS,
    payload
  };
}
export function acceptDecisionFail(payload) {
  return {
    type: actionTypes.ACCEPT_DECISION_FAIL,
    payload
  };
}
